import Cookies from 'js-cookie'
import config from 'lib/nextConfig'

export default Cookies.withAttributes({ path: config.basePath || '/' })
